import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

import { DialogRef } from '../../services/modal.service';

import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { Role } from '../../models/role.model';
import { RoleService } from '../../services/role.service';
import { Country } from '../../models/lists.model';
import { ListsService } from '../../services/lists.service';
import { ArrayJoinPipe } from '../../pipes/arrayJoin.pipe';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { ExtractAttributePipe } from '../../pipes/extractAttribute.pipe';
import { ToLabelPipe } from '../../pipes/toLabel.pipe';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';

export class MeDetailsDialogContext {
  showClose: boolean;
  isBlocking: boolean;
  size: string;
}

@Component({
  standalone: true,
  selector: 'me-details-dlg',
  styleUrls: ['me-details-dialog.component.scss'],
  templateUrl: 'me-details-dialog.component.html',
  providers: [UserService],
  imports: [ArrayJoinPipe, ExtractAttributePipe, CapitalizePipe, ToLabelPipe, TranslatePipe, CommonModule],
})
export class MeDetailsDialogComponent implements OnInit, AfterViewInit {
  context: MeDetailsDialogContext;

  user: User;
  private rolesDict: Map<string, Role>;

  constructor(
    public dialog: DialogRef<MeDetailsDialogContext>,
    private userService: UserService,
    private roleService: RoleService,
    private listService: ListsService,
    public router: Router,
  ) {
    this.context = dialog.context;

    const obs1 = this.userService.getMe();
    const obs2 = this.listService.getCountries();
    const obs3 = this.roleService.getRoles();
    forkJoin([obs1, obs2, obs3]).subscribe((data: Array<any>) => {
      this.user = data[0];
      // jointure parcelle avec les objets des listes (pour labels)
      if (this.user.country) {
        this.user.country = data[1].find((country: Country) => country.id === this.user.country.id);
      }
      const roles = data[2];
      this.rolesDict = new Map<string, Role>();
      for (const role of roles) {
        this.rolesDict.set(role.code, role);
      }
    });
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  editMe() {
    this.router.navigate(['/users', 'edit', 'me']);
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    console.log('bd');
    return false;
  }

  beforeClose(): boolean {
    console.log('bc');
    return false;
  }
}
